import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from "react";

export type Language = "zh" | "en";

const dictionary: Record<string, string> = {
  "概览": "Overview",
  "跨境电商 ERP": "Cross-border ERP",
  "全渠道运营工作台": "Omni-channel Operations",
  "店铺": "Stores",
  "商品": "Products",
  "订单": "Orders",
  "库存": "Inventory",
  "连接器": "Connectors",
  "同步任务": "Sync Jobs",
  "设置": "Settings",
  "运营概览": "Operations Overview",
  "店铺管理": "Store Management",
  "商品与 SKU": "Products & SKUs",
  "订单中心": "Order Center",
  "库存中心": "Inventory Center",
  "平台连接器": "Platform Connectors",
  "系统设置": "System Settings",
  "运营工作台": "Operations Workspace",
  "统一管理 Amazon、TikTok Shop 与 SHEIN 的订单、商品、库存和同步任务。": "Manage Amazon, TikTok Shop and SHEIN orders, products, inventory and sync jobs in one workspace.",
  "全球业务部": "Global Business",
  "搜索订单、产品、店铺、SKU...": "Search orders, products, stores, SKUs...",
  "刷新": "Refresh",
  "通知": "Notifications",
  "退出登录": "Sign out",
  "运行环境": "Runtime",
  "本地 PGlite": "Local PGlite",
  "生产切换 PostgreSQL": "PostgreSQL in production",
  "系统管理员": "System Administrator",
  "登录运营工作台": "Sign in to Operations",
  "管理全渠道订单、商品、库存和平台同步任务。": "Manage multi-channel orders, products, inventory and platform sync jobs.",
  "邮箱": "Email",
  "密码": "Password",
  "登录中...": "Signing in...",
  "进入工作台": "Enter workspace",
  "本地演示账号由 `.env` 中的管理员配置生成。": "The local demo account is generated from the administrator settings in `.env`.",
  "管理员账号由服务器环境变量配置。": "Administrator credentials are configured in the server environment.",
  "正在加载运营数据...": "Loading operations data...",
  "无法加载工作台数据：": "Unable to load dashboard data: ",
  "今日订单": "Today Orders",
  "待发货": "Pending Shipment",
  "低库存 SKU": "Low Stock SKUs",
  "同步错误": "Sync Errors",
  "较昨日持续更新": "Updating throughout the day",
  "需要仓库或供应商处理": "Needs warehouse or supplier action",
  "可用库存低于安全库存": "Available stock below safety stock",
  "失败或部分异常的同步任务": "Failed or partially completed sync jobs",
  "近 7 天订单趋势": "7-Day Order Trend",
  "按平台拆分，单位为订单数": "Split by platform, in order count",
  "平台授权和最近同步状态": "Authorization and latest sync status",
  "连接器状态": "Connector Health",
  "查看详情": "View details",
  "店铺数量": "Stores",
  "上次同步": "Last sync",
  "最近订单": "Recent Orders",
  "最近进入系统的订单": "Latest orders entering the system",
  "查看全部": "View all",
  "平台": "Platform",
  "店铺名称": "Store",
  "订单号": "Order No.",
  "状态": "Status",
  "金额": "Amount",
  "国家": "Country",
  "下单时间": "Ordered At",
  "低于安全库存的 SKU": "SKUs below safety stock",
  "安全": "Safety",
  "共 {count} 个店铺": "{count} stores",
  "新增店铺": "New Store",
  "一键授权": "One-click Authorization",
  "一键授权店铺": "Authorize Store",
  "开始授权": "Start Authorization",
  "授权中...": "Authorizing...",
  "点击开始后会跳转到平台官方页面，完成登录和授权后自动创建店铺。": "You will be redirected to the official platform page. The store is created automatically after login and consent.",
  "授权成功，店铺已创建": "Authorization successful. Store created.",
  "授权失败": "Authorization failed",
  "区域": "Region",
  "平台店铺 ID": "External Shop ID",
  "最近同步": "Last Sync",
  "操作": "Actions",
  "保存中...": "Saving...",
  "保存店铺": "Save Store",
  "取消": "Cancel",
  "搜索 SKU、SPU 或商品名称": "Search SKU, SPU or product name",
  "新增商品": "New Product",
  "商品名称": "Product Name",
  "类目": "Category",
  "品牌": "Brand",
  "成本": "Cost",
  "保存商品": "Save Product",
  "订单号或买家": "Order no. or buyer",
  "全部平台": "All Platforms",
  "全部状态": "All Statuses",
  "待付款": "Pending Payment",
  "已发货": "Shipped",
  "已送达": "Delivered",
  "已退款": "Refunded",
  "已取消": "Cancelled",
  "启用": "Active",
  "停用": "Disabled",
  "异常": "Error",
  "部分异常": "Partially Failed",
  "失败": "Failed",
  "已跳过": "Skipped",
  "执行中": "Running",
  "导入订单": "Import Orders",
  "买家": "Buyer",
  "导入订单 CSV": "Import Orders CSV",
  "支持列：platform、store、order_no、sku、title、quantity、unit_price、buyer、country、currency、ordered_at。": "Supported columns: platform, store, order_no, sku, title, quantity, unit_price, buyer, country, currency, ordered_at.",
  "导入 {imported} 条，跳过 {skipped} 条，错误 {errors} 条。": "Imported {imported}, skipped {skipped}, errors {errors}.",
  "关闭窗口": "Close",
  "导入中...": "Importing...",
  "开始导入": "Start Import",
  "搜索 SKU 或商品": "Search SKU or product",
  "全部仓库": "All Warehouses",
  "深圳主仓": "Shenzhen Main Warehouse",
  "美国海外仓": "US Overseas Warehouse",
  "仓库": "Warehouse",
  "可用": "Available",
  "占用": "Reserved",
  "在途": "In Transit",
  "安全库存": "Safety Stock",
  "更新时间": "Updated At",
  "调整": "Adjust",
  "调整库存": "Adjust Inventory",
  "当前可用": "Current available",
  "调整数量，正数入库，负数出库": "Quantity adjustment: positive in, negative out",
  "提交中...": "Submitting...",
  "提交调整": "Submit Adjustment",
  "已连接": "Connected",
  "Amazon Selling Partner API，订单、商品、库存、FBA 和报告。": "Amazon Selling Partner API for orders, products, inventory, FBA and reports.",
  "TikTok Shop Partner API，店铺授权、订单、商品、履约和物流。": "TikTok Shop Partner API for authorization, orders, products, fulfillment and logistics.",
  "SHEIN Open Platform，签名、加解密、商品、订单和库存。": "SHEIN Open Platform for signing, encryption, products, orders and inventory.",
  "订单读取": "Order Read",
  "商品读取": "Product Read",
  "库存读取": "Inventory Read",
  "发货回传": "Fulfillment Write-back",
  "报告与对账": "Reports & Reconciliation",
  "库存同步": "Inventory Sync",
  "履约回传": "Fulfillment Write-back",
  "Webhook": "Webhook",
  "采购单": "Purchase Orders",
  "需启用": "Needs Enablement",
  "未配置": "Not Configured",
  "官方文档": "Official Docs",
  "配置凭证": "Configure Credentials",
  "配置": "Configure",
  "保存后不会在页面回显": "Not displayed after saving",
  "测试连接": "Test Connection",
  "测试中...": "Testing...",
  "Amazon 本地模拟连接成功": "Amazon mock connection succeeded.",
  "TikTok Shop 本地模拟连接成功": "TikTok Shop mock connection succeeded.",
  "SHEIN 本地模拟连接成功": "SHEIN mock connection succeeded.",
  "Amazon SP-API 连接成功": "Amazon SP-API connection succeeded.",
  "SHEIN Open API 连接成功": "SHEIN Open API connection succeeded.",
  "断开授权": "Disconnect",
  "确认断开该店铺授权？": "Disconnect this store authorization?",
  "已断开店铺授权": "Store authorization disconnected.",
  "保存并启用": "Save and Enable",
  "手动触发同步": "Run Sync Manually",
  "当前本地演示模式会生成同步任务并记录结果。": "Local demo mode creates a sync job and records the result.",
  "订单同步会读取平台数据并幂等写入订单中心。": "Order sync reads platform data and idempotently writes it to the order center.",
  "订单同步完成": "Order sync completed",
  "商品同步完成": "Product sync completed",
  "4 条订单缺少 SKU 映射": "4 orders are missing SKU mappings",
  "Amazon SP-API 本地演示同步完成": "Amazon SP-API local demo sync completed",
  "全部店铺": "All Stores",
  "任务类型": "Job Type",
  "订单同步": "Order Sync",
  "商品同步": "Product Sync",
  "执行同步": "Run Sync",
  "执行中...": "Running...",
  "同步任务记录": "Sync Job History",
  "记录任务状态、数量、错误和最近执行结果。": "Track status, counts, errors and latest execution results.",
  "任务": "Job",
  "总数": "Total",
  "成功": "Success",
  "错误": "Errors",
  "开始时间": "Started At",
  "说明": "Message",
  "已接入店铺": "Connected stores",
  "内部 SKU": "Internal SKUs",
  "已同步订单": "Synced orders",
  "所有仓库可用库存": "Available stock across warehouses",
  "数据库": "Database",
  "演示数据": "Demo Data",
  "开启": "Enabled",
  "目标服务器": "Target Server",
  "运行模式": "Runtime Mode",
  "当前部署目标和数据库模式。": "Current deployment target and database mode.",
  "生产数据库": "Production Database",
  "PostgreSQL，切换 DATABASE_URL 即可": "PostgreSQL; switch DATABASE_URL",
  "部署方式": "Deployment",
  "Node.js + systemd + Nginx，无需 Docker": "Node.js + systemd + Nginx, no Docker required",
  "请求参数不合法": "Invalid request parameters",
  "邮箱或密码不正确": "Invalid email or password",
  "店铺不存在": "Store not found",
  "商品不存在": "Product not found",
  "产品采集": "Product Collection",
  "商品编辑": "Product Editor",
  "采集箱": "Collection Box",
  "定价模板": "Pricing Templates",
  "创建产品": "Create Product",
  "产品信息": "Product",
  "售价": "Price",
  "刊登": "Publishing",
  "未设置类目": "No category",
  "无品牌": "No brand",
  "未刊登": "Not published",
  "暂无商品，先采集或创建一个产品。": "No products yet. Collect or create one first.",
  "商品已保存": "Product saved.",
  "保存并刊登": "Save and Publish",
  "刊登中...": "Publishing...",
  "返回商品": "Back to Products",
  "基本信息": "Basic Information",
  "填写平台刊登需要的标题、类目、品牌和描述。": "Fill in the title, category, brand and description required for publishing.",
  "产品标题": "Product Title",
  "平台类目 ID": "Platform Category ID",
  "平台类目与属性": "Platform Categories & Attributes",
  "每个刊登店铺分别选择叶子类目，并按照平台属性模板填写必填属性。刊登前系统会再次校验。": "Select a leaf category for each store and complete the required attributes from the platform template. The system validates again before publishing.",
  "同步类目树": "Sync Category Tree",
  "同步中...": "Syncing...",
  "请选择店铺": "Select a store",
  "搜索类目": "Search Categories",
  "输入类目名称或平台类目 ID": "Enter a category name or platform category ID",
  "当前类目": "Current Category",
  "尚未选择": "Not selected",
  "类目树": "Category Tree",
  "仅叶子类目可以绑定商品": "Only leaf categories can be assigned to a product",
  "当前店铺还没有类目数据": "No categories have been synced for this store",
  "点击“同步类目树”从平台读取类目。": "Click Sync Category Tree to load categories from the platform.",
  "没有匹配的类目": "No matching categories",
  "类目属性模板": "Category Attribute Template",
  "带 * 的属性是平台必填项。属性变化后请保存商品。": "Attributes marked * are required. Save the product after changing them.",
  "同步属性": "Sync Attributes",
  "请先从左侧选择叶子类目": "Select a leaf category from the left",
  "正在读取属性模板...": "Loading attribute template...",
  "该平台未返回属性，或尚未同步属性模板": "The platform returned no attributes, or the template has not been synced",
  "点击“同步属性”重试。": "Click Sync Attributes to retry.",
  "请选择": "Select",
  "产品类型": "Product Type",
  "币种": "Currency",
  "来源链接": "Source URL",
  "来源平台": "Source Platform",
  "产品描述": "Product Description",
  "产品图片": "Product Images",
  "平台属性": "Platform Attributes",
  "按平台类目要求填写属性，例如材质、颜色、尺码、适用人群。": "Fill attributes required by the platform category, such as material, color, size and audience.",
  "添加属性": "Add Attribute",
  "属性名": "Attribute",
  "属性值": "Value",
  "上传图片": "Upload Images",
  "建议上传 1200×1200 的 JPG、PNG 或 WEBP 图片，第一张作为主图。": "Upload 1200×1200 JPG, PNG or WEBP images. The first image is the main image.",
  "主图": "Main",
  "还没有产品图片": "No product images yet",
  "销售规格与 SKU": "Variants & SKUs",
  "每个 SKU 可以单独设置成本、售价、库存、重量和图片。": "Set cost, price, stock, weight and image for each SKU.",
  "新增 SKU": "Add SKU",
  "规格名称": "Variant Name",
  "重量 KG": "Weight KG",
  "选择模板": "Select Template",
  "请选择模板": "Select a template",
  "应用到 SKU": "Apply to SKUs",
  "计算中...": "Calculating...",
  "刊登店铺": "Publish Stores",
  "选择已授权店铺后保存并刊登，系统会创建刊登任务并记录平台返回结果。": "Select authorized stores, then save and publish. The system creates publish jobs and records platform responses.",
  "商品摘要": "Product Summary",
  "主 SKU": "Main SKU",
  "SKU 数量": "SKU Count",
  "图片数量": "Image Count",
  "最低售价": "Lowest Price",
  "总库存": "Total Stock",
  "从链接采集商品，快速进入编辑和刊登流程": "Collect products from links, then edit and publish",
  "链接采集与浏览器插件采集双通道": "Collect via links or the browser extension",
  "对公开页面使用链接采集；对需要登录态、容易触发验证的 1688、淘宝、天猫和拼多多页面，使用浏览器插件从当前页面采集。": "Use link collection for public pages. For 1688, Taobao, Tmall and Pinduoduo pages that require a signed-in session or often trigger verification, collect from the current page with the browser extension.",
  "浏览器插件采集": "Browser Extension",
  "链接采集": "Link Collection",
  "连接浏览器采集扩展": "Connect Browser Collector",
  "在 Chrome 或 Edge 加载 extensions/erp-collector 目录，然后使用配对码连接。扩展不会读取或上传 Cookie。": "Load the extensions/erp-collector directory in Chrome or Edge, then pair it with the code below. The extension does not read or upload cookies.",
  "生成配对码": "Generate Pairing Code",
  "生成中...": "Generating...",
  "点击复制，配对码 10 分钟内有效": "Click to copy. The code expires in 10 minutes.",
  "尚未生成配对码": "No pairing code generated",
  "最近连接": "Last seen",
  "尚未采集": "No collection yet",
  "撤销设备": "Revoke Device",
  "已撤销": "Revoked",
  "插件采集箱": "Extension Inbox",
  "浏览器插件采集的商品会先进入这里，去重后再导入商品库。": "Products collected by the extension arrive here first, are deduplicated, then imported as drafts.",
  "待处理": "Pending",
  "插件采集箱为空": "The extension inbox is empty",
  "打开货源商品页，点击右下角“采集到 ERP”。": "Open a source product page and click Collect to ERP in the lower-right corner.",
  "导入商品库": "Import as Draft",
  "查看商品": "View Product",
  "忽略": "Discard",
  "配对码已生成，请在浏览器扩展中输入": "Pairing code generated. Enter it in the browser extension.",
  "配对码已复制": "Pairing code copied.",
  "SKU": "SKU",
  "支持 1688、淘宝、拼多多等公开商品链接。采集结果会先进入草稿，确认后再刊登到 Amazon、TikTok Shop 或 SHEIN。": "Supports public product links from 1688, Taobao, Pinduoduo and more. Collected products enter drafts before publishing.",
  "粘贴商品链接，系统会读取标题、描述、价格和主图。": "Paste a product link. The system reads title, description, price and main image.",
  "开始采集": "Collect",
  "采集中...": "Collecting...",
  "采集预览": "Collection Preview",
  "来源": "Source",
  "导入商品库并编辑": "Import and Edit",
  "采集结果暂无描述": "No description collected.",
  "采集价": "Collected Price",
  "图片": "Images",
  "下一步": "Next",
  "补充类目、SKU、售价和库存": "Complete category, SKUs, price and stock",
  "采集完成，可以检查后导入商品库": "Collection completed. Review it before importing.",
  "定价模板把成本、运费、平台佣金、达人佣金、利润率和折扣组合成可复用规则。": "Pricing templates combine cost, shipping, platform commission, creator commission, margin and discount into reusable rules.",
  "创建模板": "Create Template",
  "创建定价模板": "Create Pricing Template",
  "编辑定价模板": "Edit Pricing Template",
  "模板名称": "Template Name",
  "站点": "Site",
  "利润方式": "Profit Method",
  "售价利润率": "Sale Profit Rate",
  "成本利润率": "Cost Profit Rate",
  "固定利润": "Fixed Profit",
  "利润率 %": "Profit Rate %",
  "折扣": "Discount",
  "折": "off",
  "运费方式": "Shipping Method",
  "统一运费": "Fixed Shipping",
  "按重量计费": "By Weight",
  "运费": "Shipping",
  "平台佣金 %": "Platform Commission %",
  "达人佣金 %": "Creator Commission %",
  "其他费用": "Other Fees",
  "汇率": "Exchange Rate",
  "取整方式": "Rounding",
  "不取整": "No Rounding",
  "向上取整": "Round Up",
  "向下取整": "Round Down",
  "取整到 .99": "Round to .99",
  "售价试算": "Price Calculator",
  "采购成本": "Purchase Cost",
  "折后售价": "Sale Price",
  "折前售价": "List Price",
  "预估利润": "Estimated Profit",
  "保存模板": "Save Template",
  "定价模板已应用": "Pricing template applied.",
  "全部商品": "All Products",
  "草稿": "Draft",
  "在售中": "Active",
  "已归档": "Archived",
  "全部订单": "All Orders",
  "售后/退款": "After-sales / Refund",
  "订单号、买家或运单号": "Order no., buyer or tracking no.",
  "批量标记发货": "Bulk Mark Shipped",
  "物流": "Logistics",
  "详情": "Details",
  "暂无订单": "No orders",
  "订单详情": "Order Details",
  "加载中...": "Loading...",
  "商品明细": "Order Items",
  "数量": "Qty",
  "订单总额": "Order Total",
  "买家信息": "Buyer Information",
  "付款状态": "Payment Status",
  "履约状态": "Fulfillment Status",
  "订单处理": "Order Processing",
  "订单状态": "Order Status",
  "订单备注": "Order Note",
  "保存状态和备注": "Save Status and Note",
  "发货和物流": "Shipment and Logistics",
  "物流商": "Carrier",
  "运单号": "Tracking No.",
  "物流方式": "Shipping Method",
  "发货仓": "Warehouse",
  "标记发货并保存物流": "Mark Shipped and Save Logistics",
  "操作记录": "Activity History",
  "未选择物流": "No logistics selected",
  "共 {count} 件": "{count} item(s)"
};

interface I18nContextValue {
  language: Language;
  setLanguage: (language: Language) => void;
  t: (key: string, params?: Record<string, string | number>) => string;
}

const I18nContext = createContext<I18nContextValue | null>(null);

export function I18nProvider({ children }: { children: ReactNode }) {
  const [language, setLanguageState] = useState<Language>(() => {
    const saved = localStorage.getItem("erp_language");
    return saved === "en" ? "en" : "zh";
  });

  useEffect(() => {
    document.documentElement.lang = language === "zh" ? "zh-CN" : "en";
    document.title = language === "en" ? "Cross-border ERP Operations" : "跨境 ERP 运营工作台";
    localStorage.setItem("erp_language", language);
  }, [language]);

  const value = useMemo<I18nContextValue>(() => {
    return {
      language,
      setLanguage: setLanguageState,
      t: (key, params) => {
        const template = language === "en" ? dictionary[key] ?? key : key;
        if (!params) return template;
        return Object.entries(params).reduce(
          (text, [paramKey, paramValue]) => text.replaceAll(`{${paramKey}}`, String(paramValue)),
          template
        );
      }
    };
  }, [language]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n(): I18nContextValue {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error("useI18n must be used inside I18nProvider");
  }
  return context;
}
